import React, { useState, useContext } from "react";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import PremPlayersContext from "../../contexts/premplayers-context";
import SettledWindowTransactionsContext from "../../contexts/settled-window-transactions-context";
import UserPendingTransactionsContext from "../../contexts/user-pending-transactions-context";
import { useSiteVarsFunctions } from "../../hooks/use-site-vars-functions";

export const MyBids = (props) => {
  const {getPlayerPositionById, getTeamById, getCurrentWindow } = useSiteVarsFunctions();
  const {premPlayersData, isLoadingPremPlayersData} =  useContext(PremPlayersContext);
  const {userPendingTransactionsData, isLoadingUserPendingTransactionsData, cancelPendingTransaction} = useContext(UserPendingTransactionsContext);

  // Combine and filter user's historical bids
  let userBids = [];

  if (userPendingTransactionsData.Items) {
    userBids = userBids.concat(userPendingTransactionsData.Items.filter(bid => bid.status === "pending" || bid.status === "win" || bid.status === "lose"));
  }

  // Sort bids by date (most recent first)
  userBids.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

  // Map player IDs to full player data
  const getPlayerData = (playerId) => {
    return premPlayersData.find(player => player.playerId === playerId);
  };

  return (
    <TableContainer component={Paper} sx={{ marginBottom:5 }}>
      {(isLoadingPremPlayersData || isLoadingUserPendingTransactionsData) && (
        <Stack spacing={1}>
          <Skeleton variant="rounded" width={"100%"} height={30} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
          <Skeleton variant="rounded" width={"100%"} height={26} />
        </Stack>
      )}
      {(!isLoadingPremPlayersData && !isLoadingUserPendingTransactionsData) && (
        <Table sx={{ minWidth: 390 }} size="small">
          <TableHead>
            <TableRow>
              <TableCell style={{ paddingLeft: 6, paddingRight:0,paddingBottom: 0 }}></TableCell>
              <TableCell style={{ paddingLeft: 6, paddingRight:6}}>Player</TableCell>
              <TableCell style={{ paddingLeft: 6, paddingRight:6}}>Bid</TableCell>
              <TableCell style={{ paddingLeft: 6, paddingRight:6}}>Status</TableCell>
              <TableCell style={{ paddingLeft: 6, paddingRight:6}}>Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {userBids.map((bid) => {
              const player = getPlayerData(bid.playerId);
              if (!player) return null; // Skip if player data is not found
              if (bid.window != getCurrentWindow()) return null; // Skip if bid was not made in the current window

              return (
                <TableRow key={bid.bidId}>
                  <TableCell style={{ paddingLeft: 6, paddingRight:0, paddingBottom: 0 }}>
                    <img src={`https://resources.premierleague.com/premierleague25/photos/players/110x140/${player.photo.substr(0, player.photo.indexOf('.'))}.png`} style={{ width: '40px', height: '51px' }} />
                  </TableCell>
                  <TableCell style={{ paddingLeft: 6, paddingRight:6}}>
                    <span>{player.lastName}</span>
                    <br />
                    <span style={{fontWeight: 'bold'}}>{getPlayerPositionById(player.positionId).name_short}</span> {getTeamById(player.teamId).name_short}
                  </TableCell>
                  <TableCell style={{ paddingLeft: 6, paddingRight:6}}>{bid.amount}</TableCell>
                  <TableCell style={{ paddingLeft: 6, paddingRight:6}}>{bid.status}
                  {bid.status === "pending" &&
                    <><br /><Button onClick={() => cancelPendingTransaction(bid.bidId)} variant="outlined" color="error" size="small" style={{ fontSize: "x-small", padding:0}}>Cancel</Button></>
                  }
                  </TableCell>
                  <TableCell style={{ paddingLeft: 6, paddingRight:6}}>{new Date(bid.timestamp).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }).split(',').join("")}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      )}
    </TableContainer>
  );
};